export const ACTUAL_STATE_IMAGE_ADD = "ACTUAL_STATE_IMAGE_ADD";
export const ACTUAL_STATE_IMAGE_DELETE = "ACTUAL_STATE_IMAGE_DELETE";
export const CHECK_ITEM_IMAGE_ADD = "CHECK_ITEM_IMAGE_ADD";
export const CHECK_ITEM_IMAGE_DELETE = "CHECK_ITEM_IMAGE_DELETE";
